import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UsersComponent } from 'src/app/customer-modules/apolus/users/users.component';
import { ApolusService } from 'src/app/customer-modules/apolus/shared/services/apolus.service';
import { LiteralsResolver } from 'src/app/customer-modules/apolus/shared/guards/literals.guard';
import { ActionsComponent } from 'src/app/customer-modules/apolus/actions/actions.component';
import { DashboardComponent } from 'src/app/customer-modules/apolus/dashboard/dashboard.component';
import { ApolusTypes } from 'src/app/customer-modules/apolus/shared/services/apolus-proxy.service';
import { MapTabsComponent } from 'src/app/customer-modules/apolus/maps/map-tabs/map-tabs.component';
import { AuthGuard } from 'common-cloudstudio';
import { ReportsComponent } from 'src/app/customer-modules/apolus/reports/reports.component';

/**
 * Always use full path to import components/modules/etc
 */


const routes: Routes = [
  {
    path: '',
    resolve: {
      literals: LiteralsResolver
    },
    children: [
      { path: '', redirectTo: '/default', pathMatch: 'full' },
      { path: 'dashboards', component: DashboardComponent },
      { path: 'users', component: UsersComponent },
      { path: 'actions', component: ActionsComponent },
      { path: 'maps', component: MapTabsComponent, canActivate: [AuthGuard]},
      { path: 'reports', component: ReportsComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomerRoutingModule {

  customerPaths(menuId: number) {
    const prefix = 1000;
    switch(menuId) {
      case prefix+ApolusTypes.ApolusMenuHierarchyItem.Maps:
        return 'customer/maps';
      case prefix+ApolusTypes.ApolusMenuHierarchyItem.Users:
        return 'customer/users';
      case prefix+ApolusTypes.ApolusMenuHierarchyItem.Actions:
        return 'customer/actions';
      case prefix+ApolusTypes.ApolusMenuHierarchyItem.Dashboard:
        return 'customer/dashboards';
      case prefix+ApolusTypes.ApolusMenuHierarchyItem.Reports:
        return 'customer/reports';
      default:
        return null;
    }
  }

}
